import { Component, Input, OnInit } from '@angular/core';
import { AdminServiceService } from '../../service/admin-service.service';
import { PaisService } from 'src/app/generales/services/pais.service';

@Component({
  selector: 'app-grid-management',
  templateUrl: './grid-management.component.html',
  styleUrls: ['./grid-management.component.scss'],
})
export class GridManagementComponent implements OnInit {
  @Input() set grid(value){
    if(value){
      this.getData(value);
    }
  };

  public data = undefined;
  public gains = undefined;

  constructor(
  ) { }

  ngOnInit() {
  }
  
  async getData(grid){
    this.data = grid;
  
  }

  search(ev){
    
  }
}
